import firebase from 'firebase/app';
import 'firebase/database';
import config from '../configs/config';

const firebaseApp = firebase.initializeApp(config.firebase, 'preorder');

export default firebaseApp;
